import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { mainColor, UNIT } from '../../constants';
import IconButton from '../IconButton';

type BackButtonProps = {
  onClick: () => void;
  title: string;
  subtitle: string;
  className?: string;
};

function BackButton({ onClick, title, subtitle, className }: BackButtonProps) {
  return (
    <div
      role='button'
      tabIndex={0}
      onClick={onClick}
      onKeyPress={onClick}
      className={`d-flex align-items-center col-12 col-md-8 my-2 m-md-0 ${className || ''}`}
      style={{ fontSize: UNIT * 1.125 }}
    >
      <IconButton
        label="Back"
        ariaOwns={false}
        ariaHaspopup="true"
        aria-label="Back"
        aria-haspopup={false}
      >
        <ArrowBackIcon />
      </IconButton>

      {title && (
        <div className='ml-2'>
          <p
            className='m-0 '
            style={{ fontSize: UNIT * 1.25, color: mainColor.colorBlack, fontWeight: 'bold' }}
          >
            {title}
          </p>
          <p className='m-0 h6' style={{ fontSize: UNIT * 0.75 }}>
            {subtitle}
          </p>
        </div>
      )}
    </div>
  );
}

export default BackButton;
